import { gql } from '@apollo/client/core';

export const GET_COUNTRIES = gql`
    query GetListCountries($page: Int!, $pageSize: Int!, $searchFilter: String!) {
        countries_connection(
            filters: {
                or: [
                    { name: { contains: $searchFilter } }
                    { code: { contains: $searchFilter } }
                ]
            }
            pagination: { page: $page, pageSize: $pageSize }
            sort: ["createdAt:desc"]
        ) {
            nodes {
                documentId
                name
                code
                description
                flag {
                    documentId
                    name
                    url
                }
                players {
                    documentId
                }
            }
            pageInfo {
                page
                pageCount
                pageSize
                total
            }
        }
    }
`;
